import { render } from "./CreateApiCredentialsPage.vue?vue&type=template&id=9528fe8a"
import script from "./CreateApiCredentialsPage.vue?vue&type=script&lang=js"
export * from "./CreateApiCredentialsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__